import { render, staticRenderFns } from "./floorUnitTree.vue?vue&type=template&id=2641e4d4&scoped=true"
import script from "./floorUnitTree.vue?vue&type=script&lang=js"
export * from "./floorUnitTree.vue?vue&type=script&lang=js"
import style0 from "./floorUnitTree.vue?vue&type=style&index=0&id=2641e4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641e4d4",
  null
  
)

export default component.exports